import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const Footer = () => (
    <footer className="border-t border-border bg-surface-0 mt-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
                <span className="grid place-items-center h-7 w-7 rounded-md bg-brand text-primary-foreground">
                    <Zap className="h-4 w-4" strokeWidth={2.5} />
                </span>
                <span className="font-heading font-bold">
                    outbid<span className="text-brand">.fit</span>
                </span>
            </div>
            <p className="text-xs text-muted-foreground text-center">
                Fitness apps crowd board + sponsor marketplace. List free. Bid in public. Stats on the card.
            </p>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <Link to="/market" className="hover:text-foreground transition-colors" data-testid="footer-market-link">Market</Link>
                <Link to="/wallet" className="hover:text-foreground transition-colors" data-testid="footer-wallet-link">Wallet</Link>
                <Link to="/rules" className="hover:text-foreground transition-colors" data-testid="footer-rules-link">Rules</Link>
                <Link to="/about" className="hover:text-foreground transition-colors" data-testid="footer-about-link">About</Link>
                <Link to="/demo-marc" className="hover:text-brand transition-colors" data-testid="footer-demo-link">Feedback demo</Link>
            </div>
        </div>
    </footer>
);
